<template>
    <div>
        <div v-if="menu == 0">
            <div class="row">
                <div class="vx-col w-full bg1 encabezado">
                    <p>Repaso de {{ repasoSelected.libro.nombrelibro }}</p>
                </div>
                <div class="vx-col w-full detalle">
                    <b>Unidades:</b>
                    <p class="mt-2">{{ repasoSelected.unidades }}</p>
                    <b class="mt-1">Cantidad de preguntas:</b>
                    <p class="mt-2">{{ repasoSelected.cant_preguntas }}</p>
                </div>
            </div>
            <div class="vx-row">
                <!--listado de intentos-->
                <div class="vx-col w-ful sm:w-full md:w-1/2 lg:w-1/2">
                    <!--TABLA DE INTENTOS-->
                    <p class="color1 text-2xl text-left" style="margin-top: 30px;">Historial de intentos</p>
                    <table class="table-auto w-full" v-if="setEvaluacionRealizadas.length > 0">
                        <thead>
                            <tr>
                                <th class="px-4 py-2">Intento</th>
                                <th class="px-4 py-2">Fecha</th>
                                <th class="px-4 py-2">Puntaje</th>
                                <th class="px-4 py-2">Estado</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item,key) in setEvaluacionRealizadas" :key="key">
                                <td class="border px-4 py-2">{{ key+1 }}</td>
                                <td class="border px-4 py-2">
                                    <b>Fecha inicio:</b>
                                    <p>{{ item.fecha_comienza }}</p>
                                    <b class="mt-1">Fecha finaliza:</b>
                                    <p>{{ item.fecha_finaliza }}</p>
                                </td>
                                <td class="border px-4 py-2">{{ item.calificacion }}/ {{ item.puntaje }}</td>
                                <td class="border px-4 py-2">
                                    <span v-if="item.estado == 0">En curso</span>
                                    <div v-if="item.estado == 1">
                                        <span class="mr-3">Finalizado</span>
                                        <vs-button  type="border" @click="mostrarEvaluacionIntento(item,key+1)" class="p-2" color="#4CBAD2" size="small"><i class="fa-solid fa-file-signature"></i> Ver Evaluación</vs-button>
                                    </div>
                                    <span v-if="item.estado == 2">Anulado</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div v-else>
                        <p class="color2 text-center">No hay intentos realizados</p>
                    </div>
                </div>
                <div class="vx-col w-ful sm:w-full md:w-1/2 lg:w-1/2">
                    <!--boton para empezar repaso-->
                    <vs-button @click="generateRepaso()" class="w-full mt-5" type="gradient" ><i class="fa-solid fa-circle-play"></i> Empezar repaso</vs-button> 
                </div>
            </div>
        </div>
        <div v-if="menu == 1">
            <EstudianteResponderRepasoVue :arrayPreguntas="arrayDataPreguntas.preguntas" :evaluacionEstudiante="arrayDataPreguntas.evaluacionEstudiante" :repasoSelected="repasoSelected" @changeResponse="changeResponse"/>
        </div>
         <!--modal para ver intento-->
         <vs-popup classContent="popup-example" fullscreen title="Mostrar evaluación" :active.sync="popupMostrarEvaluacion">
            <div v-if="popupMostrarEvaluacion">
                <div v-if="arrayPreguntas.length > 0">
                    <EstudianteRepasoRevisarVue :arrayPreguntas="arrayPreguntas"  :intentoSelected="intentoSelected" :evaluacionEstudiante="arrayDataPreguntas.evaluacionEstudiante" :repasoSelected="repasoSelected"/>
                </div>
            </div>
        </vs-popup>
    </div>
</template>
<script>
import GeneralMixin from '@/mixins/GeneralMixin';
const EstudianteResponderRepasoVue = () => import('./EstudianteResponderRepaso.vue');
const EstudianteRepasoRevisarVue   = () => import('./EstudianteRepasoRevisar.vue'); 
export default {
    mixins: [GeneralMixin],
    components: {
        EstudianteResponderRepasoVue,
        EstudianteRepasoRevisarVue
    },
    data() {
       return{
            menu:0,
            usuario:[],
            arrayDataPreguntas:[],
            setEvaluacionRealizadas:[],
            arrayPreguntas:[],
            intentoSelected:'',
            idPreguntaMultiple:8,
            idPreguntaAbierta:7,
            idPreguntaColumna:5,
            popupMostrarEvaluacion:false,
       } 
    },
    props:{
        repasoSelected:{
            type: Object,
            default: () => {}
        }
    },
    created(){
        this.usuario = JSON.parse(localStorage.getItem('usuario'))[0];
    },
    mounted(){
        this.getIntentosRealizados()
    },
    methods:{
        changeResponse(e){
            let me = this;
            me.menu = 0;
            me.getIntentosRealizados()
        },
        getIntentosRealizados(){
            let me = this;
            const { idusuario } = me.usuario
            me.$http.get(this.$server_url+`estudianteRepaso?getEvaluacionRealizadas=1&idEvaluacion=${me.repasoSelected.id}&idEstudiante=${idusuario}`)
                .then(function (response) {
                   me.setEvaluacionRealizadas = response.data
                })
                .catch(function () {})
        },
        generateRepaso(){
            let me = this;  
              //post
            let formData = new FormData();
            formData.append('generateRepaso',1);
            formData.append('idEvaluacion',me.repasoSelected.id);
            formData.append('idEstudiante',me.usuario.idusuario);
            me.$vs.loading()
            this.$http.post(this.$server_url+'estudianteRepaso', formData)
            .then(res => {
                me.$vs.loading.close()
                if(res.data.status == 0){
                    me.f_notificaciones(res.data.message, "danger");
                    return
                }
                me.arrayDataPreguntas = res.data;
                //en la propiedad opciones agregar una columna seleccionar = ""
                // me.arrayDataPreguntas.preguntas.forEach((i) => {
                //     if(i.id_tipo == 5){
                //         i.opciones.forEach((j) => {
                //             j.seleccionar = ""
                //         })
                //     }
                // })
                me.menu = 1;
            })
            .catch(() => {
                me.$vs.loading.close()
                me.f_notificaciones("Error al realizar la evaluación", "danger");
            })
        },
        mostrarEvaluacionIntento(item,key){
            let me = this
            me.intentoSelected = item
            me.intentoSelected.intento = "Intento " +key
            if(me.intentoSelected == '' || me.intentoSelected == null || me.intentoSelected == undefined) return me.f_notificaciones("Seleccione un intento", "warning");
            me.arrayPreguntas = []
            let formData = new FormData();
            formData.append('id_evaluacion_estudiante',this.intentoSelected.id);
            formData.append('traerEvaluacionIntento','1')
            me.$vs.loading()
            this.$http.post(this.$server_url+'estudianteRepaso', formData)
            .then(res => {
                me.$vs.loading.close()
                if(res.data.status == 0){
                    this.$vs.notify({
                        title: 'Error',
                        text: res.data.message,
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    })
                }
                me.arrayPreguntas = res.data
                //excluir las preguntas abiertas con id 7
                me.arrayPreguntas = me.arrayPreguntas.filter((i) => i.id_tipo != me.idPreguntaAbierta)
                //juntar al ultimo las preguntas abiertas 
                me.arrayPreguntas = [...me.arrayPreguntas,...res.data.filter((i) => i.id_tipo == me.idPreguntaAbierta)]
                //si es de id_tipo == 5 en la propiedad respuestas se guarda un json porque son preguntas de tipo columna
                me.arrayPreguntas.forEach((i,index) => {
                    if(i.id_tipo == 5 || i.id_tipo == 8){
                        if(i.respuestas.length > 0){
                            //si la respuesta[0].respuesta es nulo o vacio no aplico el JSON.parse
                            if(i.respuestas[0].respuesta != null && i.respuestas[0].respuesta != ''){
                                i.respuestas[0].respuesta = JSON.parse(i.respuestas[0].respuesta)
                                //si es pregunta de tipo 8 que es pregunta de seleccion multiple
                                if(i.id_tipo == 8){
                                    i.respuestas[0].respuesta.forEach((j) => {
                                        if(j.seleccionar == "true"){
                                            j.seleccionar = true
                                        }else if(j.seleccionar == "false"){
                                            j.seleccionar = false
                                        }
                                    })
                                }
                            }else{
                                //si la respuesta[0].respuesta es nulo o vacio no aplico el JSON.parse y coloco array vacio
                                i.respuestas[0].respuesta = []
                            }
                        }
                    }
                })
                me.popupMostrarEvaluacion = true
            })
            .catch(err => {
                me.$vs.loading.close()
                me.f_notificaciones("Error al traer la evaluación "+err, "danger");
            })
        },
    }
}
</script>
<style scoped>
.bg1{
    background: #7a7a7a;
}
.encabezado{
    padding: 10px;
    color:white;
    font-size:20px;
    border-top: 20px;
}
.detalle{
    border:1px solid #cecece;
    padding: 30px 10px;
}
</style>